<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createCategory" isAdd class="ml-2" :to="{ name: 'CreateOnlineCourseCategory' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData.sync="tableData"
      actionViewRouteLink="OnlineCourseCategoryDetails"
      @delete-clicked="handleDelete($event)"
      enableDrag
      dispatchUpdateOnChange
    />

    <FormButton
      v-if="tableData.length > 0 && canEdit"
      class="mt-4"
      text="saveSort"
      :disabled="tableLoading"
      @click="saveSorting()"
    />
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'OnlineCourseCategoryList',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      const headers = [{ value: 'name', text: vm.$t('categoryName') }]
      if (this.canEdit) {
        headers.push({ value: 'actionViewAndDelete', text: '', align: 'end' })
      }
      return headers
    },
    // permission & setting
    canCreate() {
      return this.$validate.allowAction('CreateCourseCategory', this.userType)
    },
    canEdit() {
      return this.$validate.allowAction('CourseCategoryDetails', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
  }),
  methods: {
    async getCourseCategoryData() {
      this.tableLoading = true
      try {
        const { data } = await this.$Fetcher.GetOnlineCourseCategories()
        this.tableData = data
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },

    // -- (刪除)
    async handleDelete(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DeleteOnlineCourseCategory(id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
          })
          this.getCourseCategoryData()
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // -- (儲存排序)
    async saveSorting() {
      if (!this.canEdit) return;
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (this.tableData.length < 1) return

      this.$store.dispatch('setLoading', true)
      try {
        await this.$Fetcher.UpdateOnlineCourseCategorySort(this.tableData.map(el => el.id))
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
        })
        this.$store.dispatch('setDataIsUpdated', false)
        this.getCourseCategoryData()
      } catch (err) {
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: OnlineCourseCategoryList')
      this.userType = this.gfGetUserType();
      this.$store.dispatch('toggleLoadingPage', false)
      await this.getCourseCategoryData(false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>
